import { formatDateTimeLabel } from "@iq/models";

function TimeClockRawEntries({ entries }) {
	const items = Array.isArray(entries) ? entries : [];

	return (
		<section className="admin-time-clock-card" aria-label="Raw time entries">
			<h3>Raw Entries</h3>
			<div className="admin-time-clock-table-wrap">
				<table className="admin-time-clock-table">
					<thead>
						<tr>
							<th>Employee</th>
							<th>Clock In</th>
							<th>Clock Out</th>
							<th>Duration</th>
							<th>Worked On</th>
						</tr>
					</thead>
					<tbody>
						{items.length === 0 ? (
							<tr>
								<td colSpan={5} className="admin-time-clock-empty-cell">
									No entries to display.
								</td>
							</tr>
						) : (
							items.map((entry) => (
								<tr key={entry.id || `${entry.userId}-${entry.clockInAt}`}>
									<td>{entry.userName}</td>
									<td>{formatDateTimeLabel(entry.clockInAt)}</td>
									<td>{entry.clockOutAt ? formatDateTimeLabel(entry.clockOutAt) : "Open"}</td>
									<td>{entry.durationSeconds > 0 ? `${Math.floor(entry.durationSeconds / 3600)}h ${String(Math.floor((entry.durationSeconds % 3600) / 60)).padStart(2, "0")}m` : "0h 00m"}</td>
									<td>{entry.workedOn || "-"}</td>
								</tr>
							))
						)}
					</tbody>
				</table>
			</div>
		</section>
	);
}

export default TimeClockRawEntries;
